import React, { Component } from 'react';
import axios from 'axios';
import { api, versao } from '../../config';

const deliveryConfirmationBasePath = `${api}/${versao}/api/entregas/delivery-confirmation`;

function fileToCompressedBlob(file){
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = (e) => {
			const img = new Image();
			img.onload = () => {
				const max = 1280;
				let w = img.width;
				let h = img.height;
				if(w > max || h > max){
					if(w > h){
						h = Math.round(h * max / w);
						w = max;
					}else{
						w = Math.round(w * max / h);
						h = max;
					}
				}
				const c = document.createElement('canvas');
				c.width = w;
				c.height = h;
				const ctx = c.getContext('2d');
				ctx.drawImage(img, 0, 0, w, h);
				c.toBlob(
					(blob) => {
						if(blob) resolve(blob);
						else reject(new Error('Falha ao gerar imagem.'));
					},
					'image/jpeg',
					0.85
				);
			};
			img.onerror = reject;
			img.src = e.target.result;
		};
		reader.onerror = reject;
		reader.readAsDataURL(file);
	});
}

export default class DeliveryConfirmation extends Component {

	cameraInputRef = React.createRef();
	galleryInputRef = React.createRef();

	state = {
		loading: true,
		error: null,
		entrega: null,
		geo: null,
		geoError: null,
		fotos: [],
		observacao: '',
		motivoNaoEntrega: '',
		submitting: false,
		success: false,
	}

	componentDidMount(){
		this.carregarEntrega();
		this.pedirGeo();
		document.addEventListener('visibilitychange', this.handleVisibilityChange);
		window.addEventListener('pageshow', this.handlePageShow);
	}

	componentDidUpdate(prevProps){
		const token = this.props.match.params.token;
		const prevToken = prevProps.match.params.token;
		if(token !== prevToken){
			this.state.fotos.forEach((f) => {
				if(f.previewUrl) URL.revokeObjectURL(f.previewUrl);
			});
			this.setState({
				loading: true,
				error: null,
				entrega: null,
				geo: null,
				geoError: null,
				fotos: [],
				observacao: '',
				motivoNaoEntrega: '',
				submitting: false,
				success: false,
			}, () => {
				this.carregarEntrega();
				this.pedirGeo();
			});
		}
	}

	componentWillUnmount(){
		document.removeEventListener('visibilitychange', this.handleVisibilityChange);
		window.removeEventListener('pageshow', this.handlePageShow);
		this.state.fotos.forEach((f) => {
			if(f.previewUrl) URL.revokeObjectURL(f.previewUrl);
		});
	}

	/** Safari volta do WhatsApp com aba em cache (bfcache) sem remount — precisa recarregar dados. */
	handleVisibilityChange = () => {
		if(document.visibilityState !== 'visible') return;
		if(this.state.success) return;
		this.carregarEntrega({ silent: true });
	}

	handlePageShow = (ev) => {
		if(!ev.persisted) return;
		if(this.state.success) return;
		this.carregarEntrega({ silent: true });
	}

	carregarEntrega = (opts = {}) => {
		const silent = !!opts.silent;
		const token = this.props.match.params.token;
		if(!silent){
			this.setState({ loading: true });
		}
		axios.get(`${deliveryConfirmationBasePath}/${token}`, {
			params: { _: Date.now() },
		})
			.then((res) => {
				this.setState({ loading: false, entrega: res.data.entrega, error: null });
			})
			.catch((err) => {
				const msg = err.response && err.response.data && err.response.data.error
					? err.response.data.error
					: 'Não foi possível carregar esta página.';
				this.setState({ loading: false, error: msg });
			});
	}

	pedirGeo = () => {
		if(!navigator.geolocation){
			this.setState({ geoError: 'Geolocalização não disponível neste aparelho.' });
			return;
		}
		navigator.geolocation.getCurrentPosition(
			(pos) => {
				this.setState({
					geo: { lat: pos.coords.latitude, lng: pos.coords.longitude },
					geoError: null,
				});
			},
			(err) => {
				this.setState({
					geoError: 'Não foi possível obter a localização. (' + err.message + ') É opcional; você pode enviar mesmo assim.',
				});
			},
			{ enableHighAccuracy: true, timeout: 20000, maximumAge: 0 }
		);
	}

	onFotosChange = (ev) => {
		const list = ev.target.files;
		if(!list || !list.length) return;
		const files = Array.from(list);
		Promise.all(files.map((f) => fileToCompressedBlob(f).then((blob) => ({
			id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
			name: f.name,
			blob,
			previewUrl: URL.createObjectURL(blob),
		}))))
			.then((novas) => {
				this.setState((prev) => ({ fotos: [...prev.fotos, ...novas] }));
			})
			.catch(() => {
				window.alert('Não foi possível ler uma ou mais fotos.');
			});
		ev.target.value = '';
	}

	removerFoto = (id) => {
		this.setState((prev) => ({
			fotos: prev.fotos.filter((f) => {
				if(f.id === id && f.previewUrl) URL.revokeObjectURL(f.previewUrl);
				return f.id !== id;
			}),
		}));
	}

	onObservacaoChange = (ev) => this.setState({ observacao: ev.target.value });

	onMotivoChange = (ev) => this.setState({ motivoNaoEntrega: ev.target.value });

	validarAntesEnviar = (resultado) => {
		const { fotos } = this.state;
		if(resultado === 'entregue' && !fotos.length){
			window.alert('Adicione pelo menos uma foto da entrega.');
			return false;
		}
		return true;
	}

	enviar = (resultado) => {
		const { motivoNaoEntrega } = this.state;
		if(resultado === 'nao_entregue' && !motivoNaoEntrega.trim()){
			window.alert('Informe o motivo da não entrega.');
			return;
		}
		if(!this.validarAntesEnviar(resultado)) return;

		const token = this.props.match.params.token;
		const { geo, fotos, observacao } = this.state;

		this.setState({ submitting: true });

		const enviarConfirmacao = (fotoUrls) => {
			const body = {
				resultado,
				fotoUrls,
				observacao: observacao.trim(),
			};
			if(geo) body.geo = geo;
			if(resultado === 'nao_entregue') body.motivoNaoEntrega = motivoNaoEntrega.trim();

			return axios.post(`${deliveryConfirmationBasePath}/${token}`, body, {
				headers: { 'Content-Type': 'application/json' },
			});
		};

		if(resultado === 'entregue'){
			const fd = new FormData();
			fotos.forEach((f, i) => {
				fd.append('fotos', f.blob, `entrega-${i}.jpg`);
			});
			axios.post(`${deliveryConfirmationBasePath}/${token}/photos`, fd)
				.then((uploadRes) => {
					const urls = uploadRes.data && Array.isArray(uploadRes.data.urls) ? uploadRes.data.urls : [];
					if(!urls.length){
						throw new Error('Resposta de upload inválida.');
					}
					return enviarConfirmacao(urls);
				})
				.then(() => {
					this.setState({ submitting: false, success: true });
				})
				.catch((err) => {
					const msg = err.response && err.response.data && err.response.data.error
						? err.response.data.error
						: (err.message || 'Erro ao enviar. Tente novamente.');
					this.setState({ submitting: false });
					window.alert(msg);
				});
		}else{
			enviarConfirmacao([])
				.then(() => {
					this.setState({ submitting: false, success: true });
				})
				.catch((err) => {
					const msg = err.response && err.response.data && err.response.data.error
						? err.response.data.error
						: 'Erro ao enviar. Tente novamente.';
					this.setState({ submitting: false });
					window.alert(msg);
				});
		}
	}

	render(){
		const {
			loading, error, entrega, geo, geoError, fotos, observacao, motivoNaoEntrega,
			submitting, success,
		} = this.state;

		if(loading){
			return (
				<div className="deliveryConfirmation">
					<p className="deliveryConfirmation-msg">Carregando…</p>
				</div>
			);
		}

		if(error){
			return (
				<div className="deliveryConfirmation">
					<p className="deliveryConfirmation-error">{error}</p>
				</div>
			);
		}

		if(success){
			return (
				<div className="deliveryConfirmation">
					<div className="deliveryConfirmation-card">
						<h1 className="deliveryConfirmation-title">Registrado</h1>
						<p className="deliveryConfirmation-msg">A confirmação foi enviada. Você pode fechar esta página.</p>
					</div>
				</div>
			);
		}

		const simpleId = entrega && entrega.pedido && entrega.pedido.simpleId
			? entrega.pedido.simpleId
			: '';
		const end = entrega && entrega.endereco ? entrega.endereco : {};
		const endText = [end.local, end.numero, end.bairro].filter(Boolean).join(', ');

		return (
			<div className="deliveryConfirmation">
				<div className="deliveryConfirmation-card">
					<h1 className="deliveryConfirmation-title">Confirmação de entrega</h1>
					{ simpleId && <p className="deliveryConfirmation-order">Pedido <strong>#{simpleId}</strong></p> }
					{ endText && <p className="deliveryConfirmation-address">{endText}</p> }

					<div className="deliveryConfirmation-block">
						<span className="deliveryConfirmation-label">Localização (opcional)</span>
						{ geo ? (
							<p className="deliveryConfirmation-ok">Capturada ({geo.lat.toFixed(5)}, {geo.lng.toFixed(5)})</p>
						) : (
							<>
								{ geoError && <p className="deliveryConfirmation-warning">{geoError}</p> }
								<button type="button" className="deliveryConfirmation-btnSecondary" onClick={this.pedirGeo}>
									Obter localização
								</button>
							</>
						) }
					</div>

					<div className="deliveryConfirmation-block">
						<span className="deliveryConfirmation-label">Fotos (obrigatórias se entregue; opcionais se não entregue)</span>
						<div className="deliveryConfirmation-photoActions">
							<button
								type="button"
								className="deliveryConfirmation-btnCamera"
								onClick={() => this.cameraInputRef.current && this.cameraInputRef.current.click()}
							>
								Tirar foto com a câmera
							</button>
							<button
								type="button"
								className="deliveryConfirmation-btnSecondary deliveryConfirmation-btnPhotoGallery"
								onClick={() => this.galleryInputRef.current && this.galleryInputRef.current.click()}
							>
								Escolher da galeria
							</button>
						</div>
						<input
							ref={this.cameraInputRef}
							type="file"
							accept="image/*"
							capture="environment"
							className="deliveryConfirmation-fileInputHidden"
							aria-hidden="true"
							tabIndex={-1}
							onChange={this.onFotosChange}
						/>
						<input
							ref={this.galleryInputRef}
							id="delivery-photo-input"
							type="file"
							accept="image/*"
							multiple
							className="deliveryConfirmation-fileInputHidden"
							aria-hidden="true"
							tabIndex={-1}
							onChange={this.onFotosChange}
						/>
						{ fotos.length > 0 && (
							<ul className="deliveryConfirmation-photoList">
								{ fotos.map((f) => (
									<li key={f.id} className="deliveryConfirmation-photoItem">
										<img src={f.previewUrl} alt={f.name} className="deliveryConfirmation-photoThumb" />
										<span className="deliveryConfirmation-photoName">{f.name}</span>
										<button
											type="button"
											className="deliveryConfirmation-btnSecondary"
											onClick={() => this.removerFoto(f.id)}
										>
											Remover
										</button>
									</li>
								)) }
							</ul>
						) }
					</div>

					<div className="deliveryConfirmation-block">
						<label className="deliveryConfirmation-label" htmlFor="delivery-obs">Observações</label>
						<textarea
							id="delivery-obs"
							className="deliveryConfirmation-textarea"
							rows={3}
							value={observacao}
							onChange={this.onObservacaoChange}
							placeholder="Detalhes opcionais"
						/>
					</div>

					<div className="deliveryConfirmation-block">
						<label className="deliveryConfirmation-label" htmlFor="delivery-reason">Motivo (se não entregue)</label>
						<textarea
							id="delivery-reason"
							className="deliveryConfirmation-textarea"
							rows={2}
							value={motivoNaoEntrega}
							onChange={this.onMotivoChange}
							placeholder="Obrigatório apenas se marcar não entregue"
						/>
					</div>

					<div className="deliveryConfirmation-actions">
						<button
							type="button"
							className="deliveryConfirmation-btnDelivered"
							disabled={submitting}
							onClick={() => this.enviar('entregue')}
						>
							{ submitting ? 'Enviando…' : 'Entregue' }
						</button>
						<button
							type="button"
							className="deliveryConfirmation-btnNotDelivered"
							disabled={submitting}
							onClick={() => this.enviar('nao_entregue')}
						>
							Não entregue
						</button>
					</div>
				</div>
			</div>
		);
	}
}
